import * as React from "react";

import { cn } from "../../lib/utils";

// eslint-disable-next-line react/prop-types
export const Input = ({
  className,
  type,
  ...props
}: React.ComponentProps<"input">): React.ReactElement => {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary-muted selection:text-card-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "hover:border-black/20 transition-colors",
        "focus-visible:border-primary/50 focus-visible:ring-primary-muted focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
};
